// Internal modules
import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { features, resolveFeatures } from '@/lib/features';
import { iwcAutofillEmailLookup } from '@/lib/emailLookup';
import { resetAllExperimentsCache } from '@/lib/experiments';
import { getGlobals, getToken, updateExperiments } from '@/lib/globals';
import { RESET_STORE_OVERRIDES_MAPPER } from '../../constants';
// @ts-expect-error untyped import
import INITIAL_DATA_QUERY from '@/initialDataQuery.graphql';
import type {
  CheckoutContentLanguageCode,
  CountryCodes,
  Maybe,
} from '@/generated/graphql';

// TODO: move this out into reactHooks - async callback hook
type queryInitialDataParams = {
  countryCode: CountryCodes;
  languageCode: Maybe<CheckoutContentLanguageCode> | undefined;
  doResetStore?: boolean;
  resetStoreOverridesKey?: keyof typeof RESET_STORE_OVERRIDES_MAPPER;
};
export const queryInitialData = ({
  countryCode,
  languageCode,
  doResetStore = true,
  resetStoreOverridesKey = 'default',
}: queryInitialDataParams): Promise<void> => {
  const { fundingSource } = window.xprops || {};
  const { device, isBasl } = getGlobals();

  const variables = {
    channel: device.channel,
    countryCode,
    countryCodeAsString: countryCode,
    fundingSource,
    isBasl,
    isBaslAsString: `${isBasl}`,
    languageCode,
    token: getToken(),
  };

  return apolloClient
    .query({
      context: {
        isBatchedQuery: true,
      },
      fetchPolicy: 'network-only',
      query: INITIAL_DATA_QUERY,
      variables,
    })
    .then(({ data }) => {
      /**
       * @TO_DO @APOLLO_MIGRATION
       * We should be able to remove this after we migrate the store to Apollo
       * since we can read the data right from the store where it is needed.
       */
      getGlobals().initialGqlData = data;

      updateExperiments();

      features.config = resolveFeatures();
      resetAllExperimentsCache();
      iwcAutofillEmailLookup();

      if (doResetStore) {
        appStore
          .getActions()
          .resetStore(RESET_STORE_OVERRIDES_MAPPER[resetStoreOverridesKey]);
      }
    });
};
